import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { RoomProvider } from "./contexts/RoomContext";
import { UserProvider } from "./contexts/UserContext";
import PrivateRoute from "./components/PrivateRoute";
import BasicSetupScreen from "./pages/BasicSetupScreen";
import AdvancedSetupScreen from "./pages/AdvancedSetupScreen";
import MyRoomScreen from "./pages/MyRoomScreen";
import UsersScreen from "./pages/UsersScreen";
import SessionHistoryScreen from "./pages/SessionHistoryScreen";
import TranscriptionsScreen from "./pages/TranscriptionsScreen";
import TranscriptionRoomDetailScreen from "./pages/TranscriptionRoomDetailScreen";
import JoinInfoScreen from "./pages/JoinInfoScreen";
import JoinSpeakerInfoScreen from "./pages/JoinSpeakerInfoScreen";
import JoinParticipantScreen from "./pages/JoinParticipantScreen";
import LoginScreen from "./pages/LoginScreen";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/advanced-setup":
        title = "";
        metaDescription = "";
        break;
      case "/my-room-screen":
        title = "";
        metaDescription = "";
        break;
      case "/users":
        title = "User Management";
        metaDescription = "Manage users in the Manaber Realtime Translation platform";
        break;
      case "/session-history":
        title = "Session History";
        metaDescription = "View room session history and listener statistics";
        break;
      case "/transcriptions":
        title = "Transcriptions";
        metaDescription = "View transcription history by room and time range";
        break;
      case "/join-info-screen":
        title = "";
        metaDescription = "";
        break;
      case "/join-speaker-info-screen":
        title = "";
        metaDescription = "";
        break;
      case "/join-participant-screen":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <AuthProvider>
      <RoomProvider>
        <UserProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/join-speaker-info-screen" element={<JoinSpeakerInfoScreen />} />
            <Route path="/join-participant-screen" element={<JoinParticipantScreen />} />

            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/rooms" element={<MyRoomScreen />} /> {/* Changed route */}
              <Route path="/users" element={<UsersScreen />} /> {/* New route for user management */}
              <Route path="/session-history" element={<SessionHistoryScreen />} />
              <Route path="/transcriptions" element={<TranscriptionsScreen />} />
              <Route path="/transcriptions/:roomId" element={<TranscriptionRoomDetailScreen />} />
              <Route path="/my-room-screen" element={<MyRoomScreen />} />
              <Route path="/create-room" element={<BasicSetupScreen />} />
              <Route path="/basic-setup/:id?" element={<BasicSetupScreen />} />
              <Route path="/advanced-setup/:id?" element={<AdvancedSetupScreen />} />
              <Route path="/join-info/:id?" element={<JoinInfoScreen />} />
              <Route path="/" element={<MyRoomScreen />} /> {/* Default route to MyRoomScreen */}
            </Route>
          </Routes>
        </UserProvider>
      </RoomProvider>
    </AuthProvider>
  );
}
export default App;
